var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kydt"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showList),expression:"showList"}],staticClass:"title1"},[_vm._v("博士后")]),(_vm.showList)?_c('listUserTwo',{attrs:{"columnId":_vm.column_id}}):_vm._e(),(!_vm.showList)?_c('detailVue',{attrs:{"articleId":_vm.article_id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }